import { ModalId } from '../../../../../enums/modalId'
import { BlockCancelInvoiceActionVariant } from '../enums/blockCancelInvoiceActionVariant'

export const getBlockCancelInvoiceActionModalId = (invoiceId: string, variant: BlockCancelInvoiceActionVariant) =>
  `${ModalId.BlockCancelInvoiceActionModal}-${invoiceId}-${variant}`
